import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';

import { EmailSettingsFacade } from '../../../services/notifications/email-settings.facade';
import { ErrorHandlerService } from '../../../services/error-handler/error-handler.base-service';
import * as fromActions from './email-settings.actions';
import { getHasMissingMandatoryConsent } from '../../account';

@Injectable()
export class EmailSettingsEffects {
  private actions$ = inject(Actions);
  private emailSettingsFacade = inject(EmailSettingsFacade);
  private errorHandlerService = inject(ErrorHandlerService);
  private store = inject(Store);

  public loadEmailSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.LoadEmailSettings),
      withLatestFrom(this.store.select(getHasMissingMandatoryConsent)),
      switchMap(([action, hasMissingMandatoryConsent]) => {
        if (hasMissingMandatoryConsent === null || hasMissingMandatoryConsent) {
          return of({ type: '[EmailSettingsEffects] Skipped - Consent Missing', payload: action });
        }
        return this.emailSettingsFacade.getEmailSettings().pipe(
          map(success => fromActions.LoadEmailSettingsSuccess({ success })),
          catchError(error => {
            this.errorHandlerService.handleError(
              '(REQUEST ERROR) on email-settings.effects.ts:loadEmailSettings$:',
              error
            );
            return [fromActions.LoadEmailSettingsFailed({ error })];
          })
        );
      })
    );
  });

  public changeEmailSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.ChangeEmailSettings),
      switchMap(({ payload }) =>
        this.emailSettingsFacade.updateEmailSettings(payload).pipe(
          map(response => fromActions.ChangeEmailSettingsSuccess({ response })),
          catchError(error => {
            this.errorHandlerService.handleError(
              '(REQUEST ERROR) on email-settings.effects.ts:changeEmailSettings$:',
              error
            );
            return [fromActions.ChangeEmailSettingsFailed({ error })];
          })
        )
      )
    );
  });
}
